import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { Stat } from '@shared/index';
import { AdminService } from '@shared-angular/services/admin.service';
import { RouteShareService } from '../services/route-share.service';

export const userStatisticsResolver: ResolveFn<Stat[]> = async (_route, _state) => {
  const adminService: AdminService = inject(AdminService);
  const rss = inject(RouteShareService);
  const botId: string = rss.botConfig._id;
  return adminService.getUserStats(botId);
};